<template lang="pug">
  modal.modal(:title='$t("shareProgram.title")' @closeModal='hideElement({ element: "shareContentModal" })')
    .column.middle
      school-group-share(forProgram)
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '../Modal'
import SchoolGroupShare from '@/components/Resource/ShareResourceModal/SchoolGroupShare'

export default {
  components: { Modal, SchoolGroupShare },
  methods: {
    ...mapActions([
      'hideElement'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal{
  --max-width: 680px;
}
</style>
